import { render, staticRenderFns } from "./CatalogFiltersPrice.vue?vue&type=template&id=7e873d50&"
import script from "./CatalogFiltersPrice.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersPrice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports